/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { DN300, N200 } from '@atlaskit/theme/colors';
import { themed, useGlobalTheme } from '@atlaskit/theme/components';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
import { h200 } from '@atlaskit/theme/typography';
const fontFamily = getFontFamily();
const fieldsetLabelStyles = css({
  display: 'inline-block',
  marginTop: 0,
  marginBottom: "var(--ds-space-050, 4px)",
  fontFamily: fontFamily
});
const getFieldsetLabelDynamicStyles = mode => css([h200({
  theme: {
    mode
  }
}), {
  color: themed({
    dark: `var(--ds-text-subtle, ${DN300})`,
    light: `var(--ds-text-subtle, ${N200})`
  })({
    theme: {
      mode
    }
  })
}]);

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const lightH200Styles = getFieldsetLabelDynamicStyles('light');

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const darkH200Styles = getFieldsetLabelDynamicStyles('dark');

/**
 * __Label__
 *
 * A label represents a caption for an item in a user interface.
 *
 * It's recommended that a label has a `4px` spacing above its associated
 * control element.
 */
export const Label = ({
  children,
  htmlFor,
  id,
  testId
}) => {
  const {
    mode
  } = useGlobalTheme();
  return jsx("label", {
    css: [mode === 'light' ? lightH200Styles : darkH200Styles, fieldsetLabelStyles],
    id: id,
    htmlFor: htmlFor,
    "data-testid": testId
  }, children);
};

/**
 * __Legend__
 *
 * A Legend represents a caption for a fieldset in a user interface.
 */
export const Legend = ({
  children
}) => {
  const {
    mode
  } = useGlobalTheme();
  return jsx("legend", {
    css: [mode === 'light' ? lightH200Styles : darkH200Styles, fieldsetLabelStyles]
  }, children);
};
export default Label;